import {Fancybox} from "@fancyapps/ui";

document.addEventListener('submit', function (btn) {
    let form = btn.target.closest('form');
    const button = form.querySelector('button');
    if (typeof form.dataset.sendAjax !== 'undefined') {
        btn.preventDefault();
        button.setAttribute('disabled', true);

        console.log('SendAjax: addEventListener');

        let formData = new FormData(form);
        const action = form.attributes.action.value;
        form.querySelectorAll('[name]').forEach(field => {
            field.classList.remove('is-error');
        });

        if (!form.classList.contains('catalog-adv-form')) {

            fetch(action, {
                method: 'POST',
                body: formData
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (data.status) {
                        formGoalSucces(Object.assign({}, form.dataset));
                        Fancybox.close();
                        document.querySelectorAll('.fancybox__container').forEach(el => el.remove());
                        Fancybox.show([{
                            type: 'inline',
                            html: '<div class="form-answer">' + data.messages + '</div>'
                        }]);
                        form.reset();
                    } else {
                        for (let error in data.errors) {
                            form.querySelector(`[name="${error}"]`).classList.add('is-error');
                        }
                        var mess = document.querySelector('.form-answer');
                        if (mess) {
                            mess.innerHTML = data.messages;
                        } else if (data.messages) {
                            formGoalSucces(Object.assign({}, form.dataset));
                            Fancybox.close();
                            document.querySelectorAll('.fancybox__container').forEach(el => el.remove());
                            Fancybox.show([{
                                type: 'inline',
                                html: '<div class="form-answer">' + data.messages + '</div>'
                            }]);
                            form.reset();
                        }

                    }
                    button.removeAttribute('disabled');
                });
        } else {
            fetch(action, {
                method: 'POST',
                body: formData
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (!data.error) {
                            formGoalSucces(Object.assign({}, form.dataset));
                        Fancybox.close();
                        document.querySelectorAll('.fancybox__container').forEach(el => el.remove());
                        Fancybox.show([{
                            type: 'inline',
                            html: '<div class="form-answer">' + data.message + '</div>'
                        }]);
                        form.reset();
                    } else {
                        for (let error in data.errors) {
                            form.querySelector(`[name="${error}"]`).classList.add('is-error');
                        }
                        var mess = document.querySelector('.form-answer');
                        if (mess) {
                            mess.innerHTML = data.messages;
                        } else if (data.message) {
                            Fancybox.close();
                            document.querySelectorAll('.fancybox__container').forEach(el => el.remove());
                            Fancybox.show([{
                                type: 'inline',
                                html: '<div class="form-answer">' + data.message + '</div>'
                            }]);
                            form.reset();
                        }

                    }
                    button.removeAttribute('disabled');
                });
        }
    }
});
